import { Button, Label, Nav } from 'react-bootstrap';
import { NavItemWrapper, PillWrapper } from '@nkr/views/center-profile/edit/styles';
import { editNavKey } from './edit-nav-key';
import { useMediaQuery } from 'react-responsive';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    activeKey: string,
    isAdmin: boolean,
    isAdminUser: boolean,
    centerId: number,
    hasChanges: boolean,
    onTabClick: (href: string) => void,
    onSave: () => void,
    onRevert?: () => void,
    onActivityLog?: () => void,
    onExport?: () => void
}

const EditNav = (props: IProps) => {
    const { app: { site } } = useAppHookContext();
    const isBigScreen = useMediaQuery({ minWidth: 1824 });
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/profile/edit` : `/admin/center/${props.centerId}/profile/edit`;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <PillWrapper isBigScreen={isBigScreen}>
                <div style={{ padding: '10px 0px', backgroundColor: 'white' }}>
                    <Nav bsStyle='pills' className='center-profile-pills'>
                        {(props.isAdmin || props.isAdminUser) && (
                            <>
                                <NavItemWrapper className='admin' active={props.activeKey == editNavKey.ADMIN} onClick={() => props.onTabClick(hrefPrefix + '/admin')}>
                                    Admin Only
                                </NavItemWrapper>

                                <li role='presentation'><div className='pill-divider'></div></li>

                                {site.organType != OrganType.Liver && (
                                    <>
                                        <NavItemWrapper active={props.activeKey == editNavKey.SRTR} onClick={() => props.onTabClick(hrefPrefix + '/srtr-data')}>
                                            SRTR Data (Admin Only)
                                        </NavItemWrapper>

                                        <li role='presentation'><div className='pill-divider'></div></li>
                                    </>
                                )}

                                <NavItemWrapper active={props.activeKey == editNavKey.TAX} onClick={() => props.onTabClick(hrefPrefix + '/tax-data')}>
                                    Taxes (Admin Only)
                                </NavItemWrapper>

                                <li role='presentation'><div className='pill-divider'></div></li>

                                {site.organType != OrganType.Liver && (
                                    <>
                                        <NavItemWrapper active={props.activeKey == editNavKey.UNOS} onClick={() => props.onTabClick(hrefPrefix + '/unos-data')}>
                                            UNOS Data (Admin Only)
                                        </NavItemWrapper>

                                        <li role='presentation'><div className='pill-divider'></div></li>
                                    </>
                                )}
                            </>
                        )}

                        <NavItemWrapper active={props.activeKey == editNavKey.CENTER_DATA} onClick={() => props.onTabClick(hrefPrefix + '/center-data')}>
                            Center Profile
                        </NavItemWrapper>

                        {site.organType == OrganType.Kidney && (
                            <>
                                <li role='presentation'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={props.activeKey == editNavKey.LAB} onClick={() => props.onTabClick(hrefPrefix + '/lab-data')}>
                                    LAB Data
                                </NavItemWrapper>

                                <li role='presentation'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={props.activeKey == editNavKey.SERVICES} onClick={() => props.onTabClick(hrefPrefix + '/services-data')}>
                                    Services
                                </NavItemWrapper>

                                <li role='presentation'><div className='pill-divider'></div></li>
                            </>
                        )}

                        {site.organType != OrganType.Kidney && (
                            <li role='presentation'><div className='pill-divider'></div></li>
                        )}

                        <NavItemWrapper active={props.activeKey == editNavKey.SEROLOGY_TESTS} onClick={() => props.onTabClick(hrefPrefix + '/serology-tests')}>
                            Serology/Tests
                        </NavItemWrapper>

                        {site.organType == OrganType.Kidney && (
                            <>
                                <li role='presentation'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={props.activeKey == editNavKey.ANATOMY_PREFS} onClick={() => props.onTabClick(hrefPrefix + '/anatomy-prefs')}>
                                    Functional Waitlist Anat
                                </NavItemWrapper>

                                <li role='presentation'><div className='pill-divider'></div></li>

                                <NavItemWrapper active={props.activeKey == editNavKey.PACKAGING} onClick={() => props.onTabClick(hrefPrefix + '/packaging')}>
                                    Packaging
                                </NavItemWrapper>
                            </>
                        )}
                    </Nav>
                </div>
            </PillWrapper>

            {props.hasChanges && (
                <div style={{ marginRight: 10 }}>
                    <Label bsStyle='warning' style={{ fontSize: '100%', padding: '.3em .6em' }}>Pending Changes!</Label>
                </div>
            )}

            {props.activeKey == editNavKey.UNOS && props.hasChanges && (
                <div style={{ marginRight: 10 }}>
                    <Button bsStyle='warning' onClick={props.onRevert}>Revert Changes</Button>
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {props.activeKey == editNavKey.ADMIN && props.onActivityLog && (
                    <Button bsStyle='link' onClick={props.onActivityLog}>
                        <span className='glyphicon glyphicon-list-alt' /> Activity Log
                    </Button>
                )}
                {props.activeKey == editNavKey.ADMIN && props.onExport && (
                    <Button bsStyle='link' onClick={props.onExport}>
                        <span className='glyphicon glyphicon-download-alt' /> Export
                    </Button>
                )}
                <Button bsStyle='primary' disabled={!props.hasChanges} onClick={props.onSave}>Save Changes</Button>
            </div>
        </div>
    )
}

export default EditNav;